import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchResourceContributions, } from "../redux/actions";
import {
    userSelector, resourceContributionSelector, rankSelector, dkpSelector,
} from "../redux/selectors";
import { toArray } from '../common/util';
import ResourceContributionItem from './ResourceContributionItem';
import HoverEdit from '../common/hoveredit';


class ResourceContributionList extends Component {

    componentDidMount() {
        this.props.getContributions(this.props.section.chapter, this.props.section.slug, this.props.resource.slug)
    }
    render() {
        return (
            <div>
                {toArray(this.props.resourceContributions.data)
                    .filter((contrib) => contrib.resource.id === this.props.resource.id)
                    .sort((a, b) => (new Date(b.created).getTime() - new Date(a.created).getTime()))
                    .map((contrib, i) => (
                        <div className="panel-adt"  key={`${i}-resource`}>
                            <HoverEdit 
                                handleDelete={this.props.delResourceContribution} 
                                target={{contrib: contrib, chapter: this.props.dkp.data[this.props.resource.section].chapter, section: this.props.resource.section}}
                                >
                                <ResourceContributionItem 
                                    contrib={contrib} 
                                    onSubmit={this.props.editResourceContribution} 
                                    chapter={this.props.dkp.data[this.props.resource.section].chapter} 
                                    section={this.props.resource.section}
                                    resource={this.props.resource}
                                    new={false} />
                            </HoverEdit>
                        </div>
                    ))}
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
    ranks: rankSelector(state),
    resourceContributions: resourceContributionSelector(state),
    dkp: dkpSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getContributions: (chapter, section, resource) => dispatch(fetchResourceContributions(chapter, section, resource)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResourceContributionList);


// WEBPACK FOOTER //
// ./src/Officer/ResourceContributionList.js